import { render, staticRenderFns } from "./world-map.vue?vue&type=template&id=2519ce3c&scoped=true&"
import script from "./world-map.vue?vue&type=script&lang=js&"
export * from "./world-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519ce3c",
  null
  
)

export default component.exports